import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/sequence-item/sequence-item.js';
      import {SequenceItemOrientation, SequenceItemLabelType, SequenceItemState} from '@oicl/openbridge-webcomponents/dist/components/sequence-item/sequence-item.js';
import {SequenceType, SequenceStyle, SequenceValue} from '@oicl/openbridge-webcomponents/dist/components/sequence-step/sequence-step.js';

      export interface Props {
     orientation?: SequenceItemOrientation;
     labelType?: SequenceItemLabelType;
     state?: SequenceItemState;
     title?: string;
     hasSubtitle?: boolean;
     subtitle?: string;
     hasDescription?: boolean;
     description?: string;
     hasStamp?: boolean;
     hasTimeStamp?: boolean;
     timeStamp?: string;
     hasDistanceStamp?: boolean;
     distanceStamp?: string;
     stepLabel?: string;
     stepType?: SequenceType;
     stepStyle?: SequenceStyle;
     stepValue?: SequenceValue | undefined;
     showStepInputConnector?: boolean;
     showStepOutputConnector?: boolean;
     stepHasIcon?: boolean
   }

      
  
      export type {SequenceItemOrientation, SequenceItemLabelType, SequenceItemState} from '@oicl/openbridge-webcomponents/dist/components/sequence-item/sequence-item.js';
export type {SequenceType, SequenceStyle, SequenceValue} from '@oicl/openbridge-webcomponents/dist/components/sequence-step/sequence-step.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcSequenceItem',
  props: {
    orientation: {},
    labelType: {},
    state: {},
    title: {},
    hasSubtitle: { type: Boolean },
    subtitle: {},
    hasDescription: { type: Boolean },
    description: {},
    hasStamp: { type: Boolean },
    hasTimeStamp: { type: Boolean },
    timeStamp: {},
    hasDistanceStamp: { type: Boolean },
    distanceStamp: {},
    stepLabel: {},
    stepType: {},
    stepStyle: {},
    stepValue: {},
    showStepInputConnector: { type: Boolean },
    showStepOutputConnector: { type: Boolean },
    stepHasIcon: { type: Boolean }
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-sequence-item',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})